import React from "react";
import { Box, Typography } from "@mui/material";
import NoListIcon from "@diligentcorp/atlas-react-icons/dist/esm/lens/NoList.js";

interface EmptyStateProps {
  title?: string;
  subtitle?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No items to display.",
  subtitle = "No policies yet",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 6, // 48px
        width: "100%",
        height: "calc(100vh - 300px)",
        minHeight: "400px",
        textAlign: "center",
      }}
    >
      {/* Illustration */}
      <Box
        sx={{
          position: "relative",
          width: 160,
          height: 132,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Background geometric shapes */}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {/* Gray rectangle (rotated) */}
          <Box
            sx={{
              position: "absolute",
              left: "125px",
              top: "35px",
              width: "65px",
              height: "130px",
              backgroundColor: "grey.200",
              transform: "rotate(30deg)",
              transformOrigin: "center",
            }}
          />
          {/* Brand accent gradient lines - Diligent Red */}
          <Box
            sx={(theme) => ({
              position: "absolute",
              left: "23px",
              top: "56.24px",
              width: "1px",
              height: "87.186px",
              background: `linear-gradient(to bottom, transparent, ${(theme.palette as any).red?.[50]})`,
              transform: "rotate(30deg)",
              transformOrigin: "center",
            })}
          />
          <Box
            sx={(theme) => ({
              position: "absolute",
              left: "89px",
              top: "-9px",
              width: "1px",
              height: "153px",
              background: `linear-gradient(to bottom, ${(theme.palette as any).red?.[50]}, transparent)`,
              transform: "rotate(30deg)",
              transformOrigin: "center",
            })}
          />
        </Box>

        {/* Icon container */}
        <Box
          sx={{
            backgroundColor: "background.paper",
            borderRadius: "12px",
            p: 1.5,
            boxShadow: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
          }}
        >
          <NoListIcon size="2xl" />
        </Box>
      </Box>

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1, // 8px
          alignItems: "center",
          width: "100%",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 500,
            color: "text.primary",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            color: "text.primary",
          }}
        >
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyState;
